export const INTEGER_QUANTITY_UNITS = new Set([
  '只', '个', '包', '袋', '瓶', '桶', '箱', '板', '把', '件',
]);

export function requiresIntegerQuantity(unit: string): boolean {
  return INTEGER_QUANTITY_UNITS.has(unit.trim());
}

export function isValidPurchaseQuantity(value: string | number, unit: string): boolean {
  const normalized = String(value).trim();
  const quantity = Number(normalized);
  if (!normalized || !Number.isFinite(quantity) || quantity <= 0) return false;
  return !requiresIntegerQuantity(unit) || Number.isInteger(quantity);
}
